export const meetingLayouts = ['custom', 'smart', 'grid', 'focus'] as const;
export type MeetingLayout = typeof meetingLayouts[number];
export const layoutNames: Record<MeetingLayout, string> = {
  custom: 'Bố cục tùy chỉnh', smart: 'Bố cục thông minh',
  grid: 'Bố cục lưới', focus: 'Tập trung vào người thuyết trình',
};
export function resolveLayout<T extends { identity: string; micOn: boolean }>(
  layout: MeetingLayout, auto: boolean, participants: T[],
) {
  const ordered = [...participants].sort((a, b) => a.identity < b.identity ? -1 : a.identity > b.identity ? 1 : 0);
  const microphones = ordered.filter(p => p.micOn);
  return { layout: auto ? 'custom' as MeetingLayout : layout,
    participants: ordered, presenters: auto ? microphones : [], automatic: auto };
}
